import { debounce } from "@mongez/reinforcements";
import type { CustomOption } from "core/catalog";
import { useCallback, useMemo } from "react";
import { TextareaInput } from "~/design-system/components/form/TextareaInput";
import { CustomOptionLabel } from "./CustomOptionLabel";

type TextareaInputOptionProps = {
  customOption: CustomOption;
  onChange?: (value: string) => void;
};

export function TextareaInputOption({
  customOption,
  onChange,
}: TextareaInputOptionProps) {
  const handleChange = useCallback(
    (value: string) => {
      if (onChange) {
        onChange(value);
      }
    },
    [onChange],
  );

  const debouncedHandleChange = useMemo(
    () => debounce(handleChange, 500),
    [handleChange],
  );
  return (
    <TextareaInput
      name={customOption.id}
      label={<CustomOptionLabel customOption={customOption} />}
      placeholder={customOption.description}
      defaultValue={customOption.defaultValue as string}
      onChange={debouncedHandleChange}
      rows={4}
      classes={{
        wrapper: "w-full",
        input: "bg-white",
        label: "w-fit",
      }}
    />
  );
}
